import { Heading, Layout } from "@shopify/polaris";
import React, { useState } from "react";
import ReactGA from "react-ga4";

interface ErrorProps {
    errorCode: string;
}

export default function ErrorPage({ errorCode }: ErrorProps) {
    const [error, setError] = useState<string>("");

    React.useEffect(() => {
        if (errorCode === "404") {
            ReactGA.event({
                category: "Error",
                action: "page not found",
                value: 0
            });
            setError("That page could not be found");
        } else if (errorCode === "403" || errorCode === "401") {
            setError("You are not authorized to view that page.");
            ReactGA.event({
                category: "Error",
                action: "unauthorised user",
                value: 0
            });
        } else {
            setError("Internal Server Error.");
            ReactGA.event({
                category: "Error",
                action: "internal error",
                value: 0
            });
        }
    }, [errorCode]);

    return (
        <Layout.Section>
            <Heading element="h1">
                Error {errorCode !== "undefined" ? errorCode : 500}
            </Heading>
            <p>{error}</p>
        </Layout.Section>
    );
}
